import React, { useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {  Link, useParams } from 'react-router-dom';
import ErrorMessageBox from '../../components/ErrorMessageBox';
import { Loading } from '../../components/Loading';

import useQueryString from '../../../utils/hooks/useQueryString';
import { fetchRecommendBooks } from '../ducks/schoolRecommendBooks';
import { scrollToElement } from '../../../lib/userFunctions';

const SchoolRecommendBooks = ()=>{
    const dispatch = useDispatch();
    // const [id, setId] = useState(0);
    const schoolRecommendList = useSelector(state => state.schoolRecommendList);
    const schoolRecommendBooks = useSelector(state => state.schoolRecommendBooks);
    const { id } = useQueryString();

    // id가 없을때를 위해서
    useEffect(() => {
        scrollToElement();
        if(id===undefined){
            if(schoolRecommendList.result && schoolRecommendList.lists.length>0){
                const id = schoolRecommendList.lists[0].id;
                dispatch( fetchRecommendBooks(id) );
            }
        }else if(schoolRecommendBooks.id!==id){
            dispatch( fetchRecommendBooks(id) );
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, schoolRecommendList, id]);


    // if( schoolRecommendBooks.loading) return <Loading />;
    if( null!==schoolRecommendBooks.message)return <ErrorMessageBox message={schoolRecommendBooks.message} />;
    if( !schoolRecommendBooks.loading && schoolRecommendBooks.list.length===0){
        return <div className='no_data'>추천도서가 없습니다.</div>
    }
        
    
    return (
        <div className="section">
            <div className="inner">
                <div className="cont_wrap cont1">
                    <h3>1 &middot; 2학년</h3>
                    <RecommendBookGroup list={ schoolRecommendBooks.list.filter(item=>item.groupNum===1) } />
                </div>
                <div className="cont_wrap cont2">
                    <h3>3 &middot; 4학년</h3>
                    <RecommendBookGroup list={ schoolRecommendBooks.list.filter(item=>item.groupNum===2) } />
                </div>
                <div className="cont_wrap cont3">
                    <h3>5 &middot; 6학년</h3>
                    <RecommendBookGroup list={ schoolRecommendBooks.list.filter(item=>item.groupNum===3) } />
                </div>
                <Loading overlay={true} active={schoolRecommendBooks.loading} />
            </div>
        </div>
    );

}// end class
export default SchoolRecommendBooks;

const RecommendBookGroup = ({list})=>{
    const { school } = useParams();
    
    if(list===undefined) return null;
    
    const bookList = list.map((recommendBook)=>{
        return (
            <Link to={`/${school}/book/${recommendBook.book.isbn}`} key={recommendBook.id} >
                <div className="book_wrap">
                    <div className="book_cover">
                        <div className="book_inner">
                            <img src={(null!==recommendBook.book.image && recommendBook.book.image.startsWith('http://') )?`${recommendBook.book.image}`:recommendBook.book.image}  alt={recommendBook.book.title} />
                            <div className={`service service_${recommendBook.book.isService.toLowerCase()}`}></div>
                            {recommendBook.book.isService==='Y' && recommendBook.book.student_workbook==='Y' && <div className="workbook student"></div> }
                            {recommendBook.book.isService==='Y' && recommendBook.book.teacher_workbook==='Y' && <div className="workbook teacher"></div> }
                        </div>
                    </div>
                    <div className="book_info">
                        <p className="title">{recommendBook.book.title}</p>
                    </div>
                </div>
            </Link>
        );
    });
    return (
        <div className="book_area">
            {bookList}           
        </div>
    )
}